module.exports = __webpack_public_path__ + "static/media/mrs-teller.b59b637b.png";